export const types = {
	GET_NOTIFICATIONS: 'USER_NOTIFICATIONS/GET_NOTIFICATIONS',
	SET_NOTIFICATIONS: 'USER_NOTIFICATIONS/SET_NOTIFICATIONS',
	UPDATE_NOTIFICATION_STATUS: 'USER_NOTIFICATIONS/UPDATE_NOTIFICATION_STATUS',
	UPDATE_SHOW_PRELOADER: 'USER_NOTIFICATIONS/UPDATE_SHOW_PRELOADER',
	RESET_NOTIFICATIONS: 'USER_NOTIFICATIONS/RESET_NOTIFICATIONS'
};

export const actions = {
	getNotifications: (page, search) => ({ type: types.GET_NOTIFICATIONS, page, search }),
	setNotifications: payload => ({
		type: types.SET_NOTIFICATIONS,
		payload
	}),
	updateNotificationStatus: news => ({
		type: types.UPDATE_NOTIFICATION_STATUS,
		news
	}),
	updateShowPreloader: bool => ({ type: types.UPDATE_SHOW_PRELOADER, bool }),
	resetNotifications: () => ({ type: types.RESET_NOTIFICATIONS })
};
